import Axios, { AxiosRequestConfig } from 'axios'
import storage from 'src/utils/storage'
import { queryClient } from './react-query'
import { API_URL } from 'src/configs/constants'

export const axios = Axios.create({
  baseURL: API_URL,
})

const authRequestInterceptor = (config: AxiosRequestConfig) => {
  const token = storage.getToken()
  const modifiedConfig = { ...config }
  if (token) {
    modifiedConfig.headers.authorization = `${token}`
  }
  modifiedConfig.headers['ngrok-skip-browser-warning'] = '69420'
  modifiedConfig.headers.accept = 'application/json'
  modifiedConfig.headers['ngrok-skip-browser-warning'] = '69420'
  return modifiedConfig
}

axios.interceptors.request.use(authRequestInterceptor)

axios.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    const status = error.response?.status || 200
    if (status === 401) {
      storage.clearToken()
      queryClient.clear()
      window.location.reload()
    }
    return Promise.reject(error)
  }
)
